import React from "react";
import "./index.scss";

const View = ({canvasRef, isLearnMode}) => {
  return <canvas id="canvas" className={`canvas ${isLearnMode ? "canvas--learn" : ""}`} ref={canvasRef} />;
};

export default React.memo(View);
